import { Serializer } from '@lib/store';
import { servicingSeatmapInitialState } from './servicing-seatmap.reducer';
import { ServicingSeatmapState } from './servicing-seatmap.state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const servicingSeatmapStorageDeserializer = (rawObject: any) => {
  return {
    ...servicingSeatmapInitialState,
    model: rawObject && rawObject.model ? rawObject.model : null,
  } as ServicingSeatmapState;
};

export const servicingSeatmapStorageSync: Serializer<ServicingSeatmapState> = {
  deserialize: servicingSeatmapStorageDeserializer,
};
